import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AppState } from '../../../../app.state';
import { SuperComponent } from '../../../inside.super';
import { ConfirmationObservable } from '../../../../services.module/message.observable';
import { ConfirmModel } from '../../../../model.module/modals.model';
import { Nachricht } from '../../../../../generated/api/kreditportalBackendAPI.schemas';
import { NachrichtenApiService } from '../../../../../generated/api/nachrichten/nachrichten.service';

@Component({
    selector: 'nachricht',
    templateUrl: './nachricht.component.html',
    styleUrls: ['../../../commonless/content.less', './nachricht.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class NachrichtComponent extends SuperComponent implements OnInit, OnDestroy {

    task: string;

    currentOffset = 0;

    searchTerm = '';

    visibleNachricht: Nachricht;

    constructor(
        protected readonly router: Router,
        protected readonly nachrichtenApiService: NachrichtenApiService,
        protected readonly state: AppState,
        protected readonly confirmHandler: ConfirmationObservable,
        protected readonly route: ActivatedRoute
    ) {
        super();
    }

    ngOnInit() {
        this.loadNachricht();


    }

    private reloadList() {
        setTimeout(() => {
            this.loadNachricht();
        }, 1000);
    }

    private loadNachricht() {
        const nachrichtId = +this.route.snapshot.queryParamMap.get('param');

        // ODOT könnte getNachricht (Singular) heißen
        this.nachrichtenApiService.getNachrichtenById(nachrichtId).subscribe(res => {
            this.visibleNachricht = res;
            this.markMessageAsRead(res.id);
        });
    }

    ngOnDestroy() {
        this.searchTerm = null;
    }

    goToTarget = (line: any, args: any): void => {
        this.state.storeURL();
        this.router.navigate([line], {queryParams: args});
    }

    markMessageAsRead(nachrichtId: number) {
        this.nachrichtenApiService.setGelesenStatus(nachrichtId, { isGelesen: true }).subscribe(
            () => this.visibleNachricht.gelesen = true
        );
    }

    markMessageAsUnread = (nachrichtId: number): void => {
        this.nachrichtenApiService.setGelesenStatus(nachrichtId, { isGelesen: false }).subscribe(() => {
            this.visibleNachricht.gelesen = false;
            this.goToTarget('kreditportal/posteingang', { task: 'refreshList' });
        });
    }

    deleteMessage = (nachrichtId: number): void => {
        this.confirmHandler.notify(new ConfirmModel(
            'Löschen',
            'Wollen Sie diese Nachricht wirklich löschen?',
            ['Sie können diese Nachricht danach nicht wiederherstellen.'],
            (): void => {
                this.nachrichtenApiService.deleteNachrichten(nachrichtId).subscribe(
                    () => this.goToTarget('kreditportal/posteingang', {task: 'refreshList'})
                );
            },
            (): void => {
            }
        ));
    }
}
